import { t } from '@lingui/macro';

export default ({ i18n }) => ({
    CLASS_GROUP_81_TO_100_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Class Group 80 to 100')`81-100%`
    ),
    CLASS_GROUP_61_TO_80_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Class Group 61 to 80')`61-80%`
    ),
    CLASS_GROUP_41_TO_60_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Class Group 41 to 60')`41-60%`
    ),
    CLASS_GROUP_21_TO_40_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Class Group 21 to 40')`21-40%`
    ),
    CLASS_GROUP_1_TO_20_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Class Group 1 to 20')`1-20%`
    ),
    STUDENT_PROGRESS_100_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Progress 100')`100% complete`
    ),
    STUDENT_PROGRESS_81_TO_99_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Progress 81 to 99')`81-99%`
    ),
    STUDENT_PROGRESS_61_TO_80_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Progress 61 to 80')`61-80%`
    ),
    STUDENT_PROGRESS_41_TO_60_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Progress 41 to 60')`41-60%`
    ),
    STUDENT_PROGRESS_21_TO_40_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Progress 21 to 40')`21-40%`
    ),
    STUDENT_PROGRESS_1_TO_20_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Progress 1 to 20')`1-20%`
    ),
    STUDENT_ACCURACY_COMPLETE_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Accuracy Complete')`Complete`
    ),
    STUDENT_ACCURACY_81_TO_100_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Accuracy 81 to 100')`81-100%`
    ),
    STUDENT_ACCURACY_61_TO_80_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Accuracy 61 to 80')`61-80%`
    ),
    STUDENT_ACCURACY_41_TO_60_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Accuracy 41 to 60')`41-60%`
    ),
    STUDENT_ACCURACY_21_TO_40_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Accuracy 21 to 40')`21-40%`
    ),
    STUDENT_ACCURACY_1_TO_20_TEXT: i18n._(
        t('Skill Quests Mastery Legends - Student Accuracy 1 to 20')`1-20%`
    )
});



// WEBPACK FOOTER //
// ./components/skill-quests-mastery-legends/skill-quests-mastery-legends-translations.js